import React, {useContext, useEffect, useRef, useState} from 'react';

import {AppContext} from '../../AppModule/Context';
import {withWidgetContext} from '../widgetComponent/widgetContextProvider';
import CustomHooks from '../../customHooks';

import AiChatMsgComponent from './aiChatMsgComponent/aiChatMsgComponent';
import AiHandoffPendingChatMsgComponent from './aiHandoffPendingChatMsgComponent/aiHandoffPendingChatMsgComponent';
import AiHandoffStartedChatMsgComponent from './aiHandoffStartedChatMsgComponent/aiHandoffStartedChatMsgComponent';
import ChatRoomTaskOwnerComponent from './chatRoomTaskOwnerComponent/chatRoomTaskOwnerComponent';
import GetFileMessageComponent from '../fileMessageComponents/getFileMessageComponent';
import GetVoiceMsgComponent from '../audioMessagesComponents/getVoiceMsgComponent';
import ImageViewDownloadComponent from '../common/genericComponents/redesign/imageViewDownloadComponent/imageViewDownloadComponent';
import InfoComponentV2 from '../common/genericComponents/redesign/infoComponentV2/infoComponentV2';
import LeadCollectorComponent from '../widgetComponent/openWidgetComponent/leadCollectorComponent';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import SendFileComponent from './sendFileComponent';
import SendVoiceMsgComponent from '../../components/audioMessagesComponents/sendVoiceMsgComponent';
import TypingComponent from '../common/genericComponents/typingComponent';
import WidgetTitleComponent from '../widgetComponent/openWidgetComponent/widgetTitleComponent';

import expertHomeService from '../../services/expertHomeService';
import scheduleUtils from '../scheduleComponents/scheduleUtils';
import userService from '../../services/restServices/userService';
import utilsService from '../../services/utilsService';
import visibilityHandlerService from '../../services/visibilityHandlerService';
import {WSService} from '../../services/websocketService';

import VIDABOO_CONSTANTS from '../../config/consts';

import FileSendIcon from '../../assets/svgComponents/FileSendIcon';
import FileAttachIcon from '../../assets/svgComponents/FileAttachIcon';
import SendMessageIcon from '../../assets/svgComponents/SendMessageIcon';
import SmileEmojiIcon from '../../assets/svgComponents/SmileEmojiIcon';
import Check from '../../assets/svgComponents/Check';

import './clientChatboxComponent.css';
import VoiceMsgUploadingLoader from '../audioMessagesComponents/voiceMsgUploadingLoader/voiceMsgUploadingLoader';

const ClientChatBoxComponent = (props) => {
  const [srcImagePopup, setSrcImagePopup] = useState();
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [
    leadCollectorSendButtonComponent,
    setLeadCollectorSendButtonComponent,
  ] = useState(<></>);
  const [showLeadCollectorComponent, setShowLeadCollectorComponent] =
    useState(false);
  const [meta, setMeta] = useState({});
  const [showVoiceMessageUploadingLoader, setShowVoiceMessageUploadingLoader] =
    useState(false);
  const [currentlyActiveOoniChatMsg, setCurrentlyActiveOoniChatMsg] =
    useState(null);
  const [lastOoniChatMsg, setLastOoniChatMsg] = useState(null);
  const [
    messageToSendAfterFormSubmission,
    setMessageToSendAfterFormSubmission,
  ] = useState(null);
  const [isWsConnected, setIsWsConnected] = useState(
    () => WSService.socketEstablished() === true,
  );
  const prevIsWsConnected = CustomHooks.usePrevious(isWsConnected);
  const [showWsInfo, setShowWsInfo] = useState(false);
  const autoRefreshTimerRef = useRef(null);
  const pendingRefreshRef = useRef(false);
  const context = useContext(AppContext);
  const chatboxDivId = utilsService.getFormattedId(
    VIDABOO_CONSTANTS.ID_PREFIX.CHATBOX,
    props.chatRoomDto.roomId,
  );
  const showNewCompUI =
    utilsService.getIsInWidget() ||
    context.windowScreenSize === VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE ||
    props.isDemo;

  useEffect(() => {
    if (props.isDemo) return;
    const deleteWSListener = WSService.addConnectionEventListener((event) => {
      if (event === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.CONNECTED) {
        setIsWsConnected(true);
      } else {
        setIsWsConnected(false);
      }
    });
    return deleteWSListener;
  }, []);

  useEffect(() => {
    if (props.isDemo) return;
    if (autoRefreshTimerRef.current) {
      clearTimeout(autoRefreshTimerRef.current);
      autoRefreshTimerRef.current = null;
    }
    if (
      prevIsWsConnected !== undefined &&
      !prevIsWsConnected &&
      isWsConnected
    ) {
      if (visibilityHandlerService.getIsVisibilityHidden()) {
        pendingRefreshRef.current = true;
      } else {
        runRateLimitedRefresh();
      }
    } else if (!isWsConnected) {
      pendingRefreshRef.current = false;
      setShowWsInfo(false);
    }
    return () => {
      if (autoRefreshTimerRef.current) {
        clearTimeout(autoRefreshTimerRef.current);
        autoRefreshTimerRef.current = null;
      }
    };
  }, [isWsConnected]);

  useEffect(() => {
    if (props.isDemo) return;
    const deleteDoWhenVisibilityChangeListener =
      visibilityHandlerService.doWhenVisibilityChange((isHidden) => {
        if (isHidden) {
          if (autoRefreshTimerRef.current) {
            clearTimeout(autoRefreshTimerRef.current);
            autoRefreshTimerRef.current = null;
            setShowWsInfo(false);
            pendingRefreshRef.current = true;
          }
        } else {
          if (pendingRefreshRef.current && isWsConnected) {
            pendingRefreshRef.current = false;
            runRateLimitedRefresh();
          }
        }
      });
    return () => {
      deleteDoWhenVisibilityChangeListener();
    };
  }, [isWsConnected]);

  useEffect(() => {
    if (props.widgetContext.preChatClientMsgToSend) {
      //No we are sending the message automatically
      // const event = {
      //   target: {
      //     value: props.widgetContext.preChatClientMsgToSend,
      //   },
      // };
      // props.onTextareaChange(event);
      // props.widgetContext.setPreChatClientMsgToSend('');

      if (props.showLeadCollector) {
        checkIfMessageCanBeSentAndShowPreChatForm(
          props.widgetContext.preChatClientMsgToSend,
        );
        props.widgetContext.setPreChatClientMsgToSend('');
      } else {
        if (props.chatInitialized) {
          sendMessage(props.widgetContext.preChatClientMsgToSend);
          props.widgetContext.setPreChatClientMsgToSend('');
        }
      }
    }
  }, [props.widgetContext.preChatClientMsgToSend, props.chatInitialized]);

  useEffect(() => {
    const currentlyActiveOoniChatMsg = [...props.chatBoxMessages]
      .reverse()
      .find(
        (chatMessageDto) =>
          chatMessageDto.senderObjectType ===
            VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI &&
          expertHomeService.getOoniAiAction(chatMessageDto) ===
            VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING,
      );
    setCurrentlyActiveOoniChatMsg(currentlyActiveOoniChatMsg);

    const lastOoniChatMsg = [...props.chatBoxMessages]
      .reverse()
      .find(
        (chatMessageDto) =>
          chatMessageDto.senderObjectType ===
          VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI,
      );
    setLastOoniChatMsg(lastOoniChatMsg);
  }, [props.chatBoxMessages]);

  useEffect(() => {
    if (
      props.selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT &&
      !props.isDemo
    )
      props.goToChatEnd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedWidgetAppType]);

  useEffect(() => {
    const textAreaRef = props.chatTextAreaRef?.current;
    if (textAreaRef) {
      textAreaRef.rows = 1;
      if (props.messageToSend?.length) {
        const textAreaLineHeight = parseInt(
          getComputedStyle(textAreaRef).lineHeight,
          10,
        );
        const totalLines = textAreaRef.scrollHeight / textAreaLineHeight;
        const totalRows = Math.min(
          VIDABOO_CONSTANTS.TEXT_AREA_MAX_ROWS,
          Math.floor(totalLines),
        );
        textAreaRef.rows = totalRows;
      }
      textAreaRef.scrollTop = textAreaRef.scrollHeight;
    }
  }, [props.messageToSend]);

  const runRateLimitedRefresh = () => {
    if (autoRefreshTimerRef.current) {
      clearTimeout(autoRefreshTimerRef.current);
      autoRefreshTimerRef.current = null;
    }
    const now = Date.now();
    const lastRefreshTime = props.wsLastRefreshTimeRef?.current;
    const timeSince = lastRefreshTime ? now - lastRefreshTime : Infinity;
    if (timeSince >= VIDABOO_CONSTANTS.WS_AUTO_REFRESH_DELAY_MS) {
      if (props.wsLastRefreshTimeRef) props.wsLastRefreshTimeRef.current = now;
      props.reloadChatBoxMessages();
    } else {
      setShowWsInfo(true);
      autoRefreshTimerRef.current = setTimeout(() => {
        autoRefreshTimerRef.current = null;
        if (props.wsLastRefreshTimeRef)
          props.wsLastRefreshTimeRef.current = Date.now();
        setShowWsInfo(false);
        props.reloadChatBoxMessages();
      }, VIDABOO_CONSTANTS.WS_AUTO_REFRESH_DELAY_MS);
    }
  };

  const openCloseSendFileComponent = () => {
    props.openCloseSendFileComponent(!props.showSendFileComponent, null);
  };
  const setDataForImagePopup = (data) => {
    setSrcImagePopup(data.srcImagePopup);
    setShowImagePopup(data.showImagePopup);
    setMeta(data.meta);
  };

  const formatMsgTime = (millseconds) => {
    const date = new Date(millseconds);
    var monthNames = scheduleUtils.getLocaleSpecificMonths(
      context.currentLanguageLocaleKey,
    );
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var hour = addZero(date.getHours());
    var minute = addZero(date.getMinutes());

    return (
      day +
      ' ' +
      userService.capitalizeFirstLetter(monthNames[monthIndex]) +
      ' ' +
      hour +
      ':' +
      minute
    );
  };

  const addZero = (value) => {
    if (value < 10) {
      value = '0' + value;
    }
    return value;
  };

  const checkIfMessageCanBeSentAndShowPreChatForm = (messageToSend) => {
    if (props.showLeadCollector) {
      setShowLeadCollectorComponent(true);
      setMessageToSendAfterFormSubmission(messageToSend ?? props.messageToSend);
      props.goToChatEnd();
      return false;
    }
    return true;
  };

  const sendMessage = (...messageToSend) => {
    if (checkIfMessageCanBeSentAndShowPreChatForm())
      props.sendMessage(...messageToSend);
  };

  const doWhenPreChatFormIsSubmitted = (formSubmittedMsg) => {
    if (props.addLocalMessageInChatBoxMessages) {
      const formSubmissionLocalMsg = {
        sendTime: Date.now(),
        subType: VIDABOO_CONSTANTS.INFO_MESSAGE_SUBTYPES.FORM_CONFIRMATION,
        messageText: formSubmittedMsg?.trim() || 'Thank you! How can we help?',
      };
      props.addLocalMessageInChatBoxMessages(formSubmissionLocalMsg);
    }
    setShowLeadCollectorComponent(false);
    if (messageToSendAfterFormSubmission?.trim()) {
      props.sendMessage(messageToSendAfterFormSubmission);
    }
    setMessageToSendAfterFormSubmission(null);
  };
  return (
    <React.Fragment>
      {/* Here the File drop popup */}
      {props.showSendFileComponent && (
        <SendFileComponent
          handleClose={openCloseSendFileComponent}
          currentSelectedFile={props.currentSelectedFile}
          onFileSelected={(file) => {
            const currentShowStatus =
              file == null
                ? !props.showSendFileComponent
                : props.showSendFileComponent;
            props.openCloseSendFileComponent(currentShowStatus, file);
          }}
          sendMessage={sendMessage}
          senderObjectType={VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST}
          senderObjectId={props.myParticipantId}
          roomId={props.chatRoomDto && props.chatRoomDto.roomId}
          headingText={'Send file'}
        />
      )}
      {/* Show Image popup */}
      {showImagePopup && (
        <ImageViewDownloadComponent
          hideImgPreviewOnClick={true}
          src={srcImagePopup}
          fileName={meta.fileName}
          closeFunc={meta.onCancel}
          mediaMessageId={meta.mediaMessageId}
        />
      )}
      <div
        className={`${
          props.showSendFileComponent
            ? 'et-send-file-component-blur-wrap '
            : 'et-send-no-file-component-blur-wrap '
        }`}>
        <div className={`et-chat-body`}>
          {!props.isDemo && (!isWsConnected || showWsInfo) && (
            <div className="et-client-cc-socket-info-wrap">
              <InfoComponentV2
                isWarningUI={!isWsConnected}
                showAnim
                titleTxt={
                  isWsConnected ? 'Connection restored' : 'Limited connectivity'
                }
                subTitleTxt={
                  isWsConnected
                    ? "Let's pick up right where we left off"
                    : 'Hang tight while we reconnect'
                }
                btnTxt={isWsConnected ? 'Refresh' : null}
                onClick={() => {
                  if (autoRefreshTimerRef.current) {
                    clearTimeout(autoRefreshTimerRef.current);
                    autoRefreshTimerRef.current = null;
                  }
                  if (props.wsLastRefreshTimeRef)
                    props.wsLastRefreshTimeRef.current = Date.now();
                  setShowWsInfo(false);
                  props.reloadChatBoxMessages();
                }}
              />
            </div>
          )}
          <div className="et-chat-body-ul" id={chatboxDivId}>
            {props.chatBoxMessages.map((messageObj, index) => {
              if (
                messageObj.senderObjectType ===
                  VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI &&
                messageObj.metaData
              ) {
                messageObj.parsedMetaData =
                  expertHomeService.getMetaDataFromChatMessageDto(messageObj);
              }

              const showParticipantInfo =
                (props.isGroupChatRoom || props.isTeamChatRoom) &&
                !props.isDemo &&
                messageObj.senderObjectId !==
                  VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE;
              const showAutomaticMsgNewUI =
                messageObj.senderObjectId ===
                  VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE &&
                messageObj.senderObjectType ===
                  VIDABOO_CONSTANTS.AUTOMATED_MSG_TYPES.AUTOMATIC_MESSAGE &&
                (props.isDemo ||
                  utilsService.getIsInWidget() ||
                  (utilsService.getIsPersonalPage() &&
                    context.windowScreenSize ===
                      VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE));
              return messageObj.fromPeer ? (
                <div
                  key={messageObj.sendTime || index}
                  className="et-ccc-row-peer-name-msg-wrap">
                  <div
                    className={`et-box-align-left-li ${
                      showAutomaticMsgNewUI
                        ? 'et-box-align-left-li-automatic-msg'
                        : ''
                    }`}>
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE && (
                      <React.Fragment>
                        <GetVoiceMsgComponent
                          align="left"
                          participantName={
                            showParticipantInfo
                              ? props.chatRoomDto.participantsInfo[
                                  messageObj.senderObjectId
                                ]?.participantName
                              : null
                          }
                          voiceMsgId={messageObj.metaData}
                        />
                        <div className="et-chat-status-dt">
                          <p className="et-chat-time-left" dir="auto">
                            {messageObj.sendTime &&
                              formatMsgTime(messageObj.sendTime)}
                          </p>
                        </div>
                      </React.Fragment>
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI && (
                      <AiChatMsgComponent
                        isDemo={props.isDemo}
                        isMentorSide={false}
                        chatMessageDto={messageObj}
                        chatRoomDto={props.chatRoomDto}
                        currentlyActiveOoniChatMsg={currentlyActiveOoniChatMsg}
                        lastOoniChatMsg={lastOoniChatMsg}
                        mentorDto={props.mentor.mentorDto}
                        senderObjectId={props.myParticipantId}
                        senderObjectType={props.myParticipantType}
                        widgetId={props.widgetContext.widgetDto?.widgetId}
                        getTextMessage={props.getTextMessage}
                        onFooterOptionSelected={props.onFooterOptionSelected}
                      />
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_FLOW_START && (
                      <AiHandoffStartedChatMsgComponent
                        isDemo={props.isDemo}
                        isMentorSide={false}
                        chatMessageDto={messageObj}
                        chatRoomDto={props.chatRoomDto}
                        lastOoniChatMsg={lastOoniChatMsg}
                        mentorDto={props.mentor.mentorDto}
                        senderObjectId={props.myParticipantId}
                        senderObjectType={props.myParticipantType}
                        widgetId={props.widgetContext.widgetDto?.widgetId}
                        getTextMessage={props.getTextMessage}
                        onFooterOptionSelected={props.onFooterOptionSelected}
                      />
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_PENDING && (
                      <AiHandoffPendingChatMsgComponent
                        isDemo={props.isDemo}
                        isMentorSide={false}
                        chatMessageDto={messageObj}
                        chatRoomDto={props.chatRoomDto}
                        lastOoniChatMsg={lastOoniChatMsg}
                        mentorDto={props.mentor.mentorDto}
                        widgetId={props.widgetContext.widgetDto?.widgetId}
                        getTextMessage={props.getTextMessage}
                      />
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_EVENT && (
                      <ChatRoomTaskOwnerComponent
                        isDemo={props.isDemo}
                        isDisabled={props.isDemo}
                        isMentorSide={false}
                        chatMessageDto={messageObj}
                        chatRoomDto={props.chatRoomDto}
                        lastOoniChatMsg={lastOoniChatMsg}
                        mentorDto={props.mentor.mentorDto}
                        senderObjectId={props.myParticipantId}
                        senderObjectType={props.myParticipantType}
                        widgetDto={props.widgetContext.widgetDto}
                        widgetId={props.widgetContext.widgetDto?.widgetId}
                        doWhenActionClick={props.doWhenActionClick}
                        onFooterOptionSelected={props.onFooterOptionSelected}
                      />
                    )}
                    {messageObj.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE ? (
                      showAutomaticMsgNewUI &&
                      messageObj.senderObjectType ===
                        VIDABOO_CONSTANTS.AUTOMATED_MSG_TYPES
                          .AUTOMATIC_MESSAGE ? (
                        <div className="et-client-chat-box-automated-message">
                          <WidgetTitleComponent
                            title={messageObj.messageText}
                          />
                        </div>
                      ) : (
                        <React.Fragment>
                          <span className="et-box-align-left-msg">
                            {showParticipantInfo && (
                              <div className="et-ccc-chat-sender-name">
                                {
                                  props.chatRoomDto.participantsInfo[
                                    messageObj.senderObjectId
                                  ]?.participantName
                                }
                              </div>
                            )}
                            {props.getTextMessage(messageObj.messageText)}
                          </span>
                          <div className="et-chat-status-dt">
                            <p className="et-chat-time-left" dir="auto">
                              {messageObj.sendTime &&
                                formatMsgTime(messageObj.sendTime)}
                            </p>
                          </div>
                        </React.Fragment>
                      )
                    ) : null}
                    {(messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                      messageObj.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE) && (
                      <React.Fragment>
                        <GetFileMessageComponent
                          mediaMessageMeta={messageObj.metaData}
                          participantName={
                            showParticipantInfo &&
                            props.chatRoomDto.participantsInfo[
                              messageObj.senderObjectId
                            ]?.participantName
                          }
                          align="left"
                          setDataForImagePopup={setDataForImagePopup}
                          key={messageObj.sendTime}
                        />
                        <div className="et-chat-status-dt">
                          <p className="et-chat-time-left" dir="auto">
                            {messageObj.sendTime &&
                              formatMsgTime(messageObj.sendTime)}
                          </p>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              ) : (
                (messageObj.subType ===
                  VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE ||
                  messageObj.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE ||
                  messageObj.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                  messageObj.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE ||
                  messageObj.subType ===
                    VIDABOO_CONSTANTS.INFO_MESSAGE_SUBTYPES
                      .FORM_CONFIRMATION) && (
                  <div
                    key={messageObj.sendTime}
                    className={
                      messageObj.subType ===
                      VIDABOO_CONSTANTS.INFO_MESSAGE_SUBTYPES.FORM_CONFIRMATION
                        ? 'et-client-chat-box-full-width-message'
                        : 'et-box-align-right-li'
                    }>
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE && (
                      <React.Fragment>
                        <GetVoiceMsgComponent
                          align="right"
                          voiceMsgId={messageObj.metaData}
                        />
                      </React.Fragment>
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.INFO_MESSAGE_SUBTYPES
                        .FORM_CONFIRMATION && (
                      <React.Fragment>
                        <div className="et-client-chat-box-form-confirmation-wrapper">
                          <div className="et-client-chat-box-form-confirmation-icon-wrapper">
                            <Check color="#11D200" />
                          </div>
                          {messageObj.messageText}
                        </div>
                        <div className="et-client-chat-box-form-confirmation-time-wrapper">
                          <p className="et-chat-time ">
                            {messageObj.sendTime &&
                              formatMsgTime(messageObj.sendTime)}
                          </p>
                        </div>
                      </React.Fragment>
                    )}
                    {(messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                      messageObj.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE) && (
                      <React.Fragment>
                        <GetFileMessageComponent
                          mediaMessageMeta={messageObj.metaData}
                          align="right"
                          setDataForImagePopup={setDataForImagePopup}
                          key={messageObj.sendTime}
                        />
                      </React.Fragment>
                    )}
                    {messageObj.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE && (
                      <span className="et-box-align-right-msg">
                        {props.getTextMessage(messageObj.messageText)}
                      </span>
                    )}

                    {messageObj.subType !==
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE && (
                      <label className="et-box-align-left-label">
                        {messageObj.messageWasRead && (
                          <React.Fragment>
                            <i className="et-msg-show-icon fas fa-check" />
                            <i className="et-msg-show-icon fas fa-check" />
                          </React.Fragment>
                        )}
                        <p className="et-chat-time" dir="auto">
                          {messageObj.sendTime &&
                            formatMsgTime(messageObj.sendTime)}
                        </p>
                      </label>
                    )}
                  </div>
                )
              );
            })}
            {props.peerIsTyping && (
              <TypingComponent
                showMultipleUserUI={
                  props.isGroupChatRoom || props.isTeamChatRoom
                }
                participantsInfo={props.chatRoomDto.participantsInfo}
                typingParticipantsInfo={Object.values(
                  props.typingParticipantsInfoObj,
                )}
              />
            )}
            {showVoiceMessageUploadingLoader && (
              <div
                className="et-box-align-right-li et-box-align-right-msg"
                style={{padding: 5}}>
                <VoiceMsgUploadingLoader largeUI={false} />
              </div>
            )}
            {props.showLeadCollector && showLeadCollectorComponent && (
              <LeadCollectorComponent
                isDemo={props.isDemo}
                isPersonalPage={props.isPersonalPage}
                callSendMessageFunc={props.callSendMessageFunc}
                mentor={props.mentor}
                selectedWidgetAppType={props.selectedWidgetAppType}
                callbackSuccessInfoSend={(callbackObj) => {
                  if (props.callbackSuccessInfoSend)
                    props.callbackSuccessInfoSend(callbackObj);
                  doWhenPreChatFormIsSubmitted(callbackObj?.formSubmittedMsg);
                }}
                isEmbedded={true}
                setLeadCollectorSendButtonComponent={
                  setLeadCollectorSendButtonComponent
                }
              />
            )}
          </div>

          {props.showNewMsgPopup && (
            <div className="et-new-message-popup">
              <button className="et-popup-button" onClick={props.goToChatEnd}>
                New message arrived
              </button>
            </div>
          )}
        </div>

        {/* CFW-184, Websocket connect/disconnect test btns */}
        {/* <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-around',
            padding: '8px',
          }}>
          <div style={{width: '100px', height: '36px'}}>
            <MultiStateButton
              isPrimaryBtn
              btnTxt="Connect"
              onClick={() => WSService.connect()}
            />
          </div>
          <div style={{width: '100px', height: '36px'}}>
            <MultiStateButton
              isDeleteBtn
              btnTxt="Disconnect"
              onClick={() => WSService.disconnect()}
            />
          </div>
        </div> */}
        {props.showLeadCollector && showLeadCollectorComponent ? (
          leadCollectorSendButtonComponent
        ) : (
          <div className="et-send-speaker-box">
            <div className="et-typing-area-emoji-file-wrap">
              <div className="et-typing-area">
                <textarea
                  ref={props.chatTextAreaRef}
                  dir="auto"
                  className="et-typing-input"
                  onChange={props.onTextareaChange}
                  value={props.messageToSend}
                  type="text"
                  id="txt"
                  rows={1} // default no. of rows
                  spellCheck={true}
                  onKeyDown={(e) => {
                    if (props.showLeadCollector) {
                      if (e.key === 'Enter') {
                        setShowLeadCollectorComponent(true);
                        setMessageToSendAfterFormSubmission(
                          props.messageToSend,
                        );
                      }
                      return;
                    }
                    props.onKeyDown(e);
                  }}
                  onBlur={props.sendUserStoppedTyping}
                  placeholder={
                    props?.mentor?.mentorDto?.appControlDto
                      ?.widgetEditableTexts[
                      VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES.TEXT_CHAT
                    ] ||
                    context.languageSet.CONSOLTO_WIDGET.SAY_SOMETHING + '...'
                    // 'Say something cool…'
                  }
                />
              </div>
              <div
                className={`et-smiley-record-send ${
                  props.messageToSend && props.messageToSend !== ''
                    ? 'et-smiley-record-send-client-text-input'
                    : 'et-smiley-record-send-client'
                }`}>
                {showNewCompUI ? (
                  <div
                    className="et-client-chat-box-emoji-icon"
                    onClick={props.handleEmojiBox}>
                    <SmileEmojiIcon fillColor="var(--et-mentor-input-field-bubble-text-color)" />
                  </div>
                ) : (
                  <i
                    onClick={props.handleEmojiBox}
                    className="et-smiley-send-icon-client far fa-smile"
                  />
                )}
                {(!props.messageToSend || props.messageToSend === '') && (
                  <>
                    {!showNewCompUI && (
                      <SendVoiceMsgComponent
                        isDemo={props.isDemo}
                        showNewUI={showNewCompUI}
                        senderObjectType={
                          VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST
                        }
                        senderObjectId={props.myParticipantId}
                        chatRoomId={
                          props.chatRoomDto && props.chatRoomDto.roomId
                        }
                        sendAudioMessageNotification={
                          props.sendAudioMessageNotification
                        }
                        isMentor={false}
                        sendGA={props.sendGA}
                        showUploadingLoader={() => {
                          setShowVoiceMessageUploadingLoader(true);
                          props.goToChatEnd();
                        }}
                        hideUploadingLoader={() => {
                          setShowVoiceMessageUploadingLoader(false);
                        }}
                        checkIfMessageCanBeSent={
                          checkIfMessageCanBeSentAndShowPreChatForm
                        }
                      />
                    )}
                    <div
                      className="et-client-chat-box-icon-send-file"
                      onClick={() =>
                        checkIfMessageCanBeSentAndShowPreChatForm() &&
                        !props.isDemo &&
                        props.openCloseSendFileComponent(true, null)
                      }>
                      {showNewCompUI ? (
                        <FileAttachIcon fillColor="var(--et-mentor-input-field-bubble-text-color)" />
                      ) : (
                        <FileSendIcon fillColor="var(--et-mentor-input-field-bubble-text-color)" />
                      )}
                    </div>
                  </>
                )}
                {!showNewCompUI &&
                  props.messageToSend &&
                  props.messageToSend !== '' && (
                    <i
                      className="et-smiley-send-icon-client fas fa-arrow-right"
                      onClick={() => sendMessage(props.messageToSend)}
                    />
                  )}
              </div>
            </div>
            {showNewCompUI &&
              props.messageToSend &&
              props.messageToSend !== '' && (
                <div className="et-client-send-msg-icon-wrap">
                  <MultiStateButton
                    isPrimaryBtn
                    leftImage={
                      utilsService.getIsInWidget() || props.isDemo ? (
                        <SendMessageIcon fillColor="var(--et-mentor-input-field-bubble-text-color)" />
                      ) : (
                        <i className="et-smiley-send-icon-client fas fa-arrow-right" />
                      )
                    }
                    onClick={() => sendMessage(props.messageToSend)}
                  />
                </div>
              )}
            {showNewCompUI &&
              (!props.messageToSend || props.messageToSend === '') && (
                <div className="et-client-send-voice-msg-wrap">
                  <SendVoiceMsgComponent
                    isDemo={props.isDemo}
                    showNewUI={showNewCompUI}
                    senderObjectType={
                      VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST
                    }
                    senderObjectId={props.myParticipantId}
                    chatRoomId={props.chatRoomDto && props.chatRoomDto.roomId}
                    sendAudioMessageNotification={
                      props.sendAudioMessageNotification
                    }
                    isMentor={false}
                    sendGA={props.sendGA}
                    checkIfMessageCanBeSent={
                      checkIfMessageCanBeSentAndShowPreChatForm
                    }
                  />
                </div>
              )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default withWidgetContext(ClientChatBoxComponent);
